import styled from '@emotion/styled'
import { typo } from '@mathflat/common/style'
import colors from '@mathflat/common/style/colors'

const S = {
  Tooltip: styled.div`
    display: flex;
    margin-left: 4px;

    &.green {
      svg path {
        fill: ${colors.deepGreen};
      }

      p {
        color: ${colors.deepGreen};
      }
    }
    &.warn {
      svg path {
        fill: ${colors.red.$400};
      }

      p {
        color: ${colors.red.$400};
      }
    }
    &.gray {
      svg path {
        &:hover {
          fill: ${colors.gray.$700};
        }
      }

      p {
        color: ${colors.gray.$500};
      }
    }

    > div {
      display: inline-flex;
      align-items: center;
      cursor: pointer;
    }
    p {
      margin-right: 4px;
      font-weight: bold;
      ${typo.caption02};
    }
  `,
  Overlay: styled.div`
    padding: 12px 16px;
    border-radius: var(--Radius-100);
    color: white;

    &.green {
      background-color: ${colors.deepGreen};
    }
    &.warn {
      background-color: ${colors.red.$400};
      opacity: 0.9;
    }
    &.gray {
      background-color: ${colors.gray.$700};
      opacity: 0.9;
    }
  `,
}

export default S
